import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const VideoIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3 2.36526C1.89543 2.36526 1 3.26069 1 4.36526V12.3653C1 13.4699 1.89543 14.3653 3 14.3653H13C14.1046 14.3653 15 13.4699 15 12.3653V4.36526C15 3.26069 14.1046 2.36526 13 2.36526H3ZM6.93536 5.35585C6.53684 5.08723 6 5.37277 6 5.85338V10.8774C6 11.358 6.53685 11.6435 6.93537 11.3749L10.6619 8.86279C11.0148 8.62495 11.0148 8.10559 10.6619 7.86775L6.93536 5.35585Z"
		/>
	</svg>
))
